/**
 * Created by maximus on 14.10.16.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require("redbox-react");

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require("react");

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require("react-transform-catch-errors");

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _helpers = require("helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    MobileCatalog: {
        displayName: "MobileCatalog"
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: "/usr/local/ibonus/src/components/Hamburger/MobileCatalog/MobileCatalog.jsx",
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var MobileCatalog = _wrapComponent("MobileCatalog")((_temp = _class = function (_Component) {
    (0, _inherits3.default)(MobileCatalog, _Component);

    function MobileCatalog(props) {
        (0, _classCallCheck3.default)(this, MobileCatalog);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MobileCatalog.__proto__ || (0, _getPrototypeOf2.default)(MobileCatalog)).call(this, props));

        _this.handleInDepthClick = function (_ref) {
            var item = _ref.item,
                array = _ref.array;

            _this.setState({
                title: item.title,
                category: array,
                prev: (0, _extends3.default)({}, _this.state),
                animationType: 'slide_to_left'
            });
        };

        _this.handleBackClick = function (e) {
            if (_this.state.prev) {
                _this.setState((0, _extends3.default)({}, _this.state.prev, {
                    animationType: 'slide_to_right'
                }));
            } else {
                _this.props.handleBackClick();
            }
        };

        _this.state = {
            title: _this.props.title,
            category: _this.props.categories,
            prev: null,
            animationType: 'slide_to_left'
        };
        return _this;
    }

    (0, _createClass3.default)(MobileCatalog, [{
        key: "render",
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('MobileCatalog', null, { folderName: "Hamburger/MobileCatalog" });

            return _react3.default.createElement(View, (0, _extends3.default)({}, this.state, {
                handleClick: this.props.handleClick,
                handleInDepthClick: this.handleInDepthClick,
                handleBackClick: this.handleBackClick
            }));
        }
    }]);
    return MobileCatalog;
}(_react2.Component), _class.propTypes = {}, _temp));

exports.default = MobileCatalog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Hamburger/MobileCatalog/MobileCatalog.jsx
// module id = 1668
// module chunks = 0